module.exports = __webpack_public_path__ + "img/man.06e9f4c5.png";